// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Vendor Component Styles */
.vendor-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

/* Title */
.vendor-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 16px;
}

/* Controls (Search and Add Button) */
.vendor-controls {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  justify-content: space-between;
}

.vendor-search-input {
  flex: 1 1;
  max-width: 600px;
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.vendor-add-button {
  background-color: #06b6d4;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

/* Popup Form */
.vendor-form-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.vendor-form-container {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.vendor-form-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.vendor-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vendor-name-input,
.vendor-number-input {
  padding: 8px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.vendor-name-input:focus,
.vendor-number-input:focus {
  border-color: #06b6d4;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.vendor-form-buttons {
  display: flex;
  gap: 16px;
}

.vendor-submit-button {
  background-color: #06b6d4;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.vendor-submit-button:hover {
  background-color: #06b6d4;
}

.vendor-cancel-button {
  background-color: #d1d5db;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.vendor-cancel-button:hover {
  background-color: #9ca3af;
}

/* Table */
.vendor-table-container {
  overflow-x: auto;
}

.vendor-table {
  width: 100%;
  border-collapse: collapse;
}

.vendor-table-header {
  background-color: #f3f4f6;
}

.vendor-table-th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #1f2937;
}

.vendor-table-row {
  border-bottom: 1px solid #e5e7eb;
}

.vendor-table-row:hover {
  background-color: #f9fafb;
}

.vendor-table-td {
  padding: 12px;
}

.vendor-edit-button {
  /* background-color: #eab308; */
  color: rgb(0, 0, 0);
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  font-size: 0.875rem;
  cursor: pointer;
  margin-right: 8px;
  transition: background-color 0.2s;
}

.vendor-edit-button:hover {
  /* background-color: #ca8a04; */
}

.vendor-delete-button {
  /* background-color: #ef4444; */
  color: rgb(0, 0, 0);
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.vendor-delete-button:hover {
  /* background-color: #dc2626; */
}

.vendor-no-data {
  text-align: center;
  color: #6b7280;
  padding: 16px;
}

/* Responsive Design */
@media (min-width: 640px) {
  .vendor-controls {
    flex-direction: row;
  }

  .vendor-form-container {
    max-width: 500px;
  }
}

@media (max-width: 639px) {
  .vendor-container {
    padding: 12px;
  }

  .vendor-table-th,
  .vendor-table-td {
    padding: 8px;
  }

  .vendor-edit-button,
  .vendor-delete-button {
    padding: 4px 8px;
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Registration/vendor.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":["/* Vendor Component Styles */\n.vendor-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px;\n}\n\n/* Title */\n.vendor-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n/* Controls (Search and Add Button) */\n.vendor-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n  justify-content: space-between;\n}\n\n.vendor-search-input {\n  flex: 1;\n  max-width: 600px;\n  padding: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.vendor-add-button {\n  background-color: #06b6d4;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n/* Popup Form */\n.vendor-form-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n}\n\n.vendor-form-container {\n  background-color: white;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n}\n\n.vendor-form-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.vendor-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.vendor-name-input,\n.vendor-number-input {\n  padding: 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.vendor-name-input:focus,\n.vendor-number-input:focus {\n  border-color: #06b6d4;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.vendor-form-buttons {\n  display: flex;\n  gap: 16px;\n}\n\n.vendor-submit-button {\n  background-color: #06b6d4;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.vendor-submit-button:hover {\n  background-color: #06b6d4;\n}\n\n.vendor-cancel-button {\n  background-color: #d1d5db;\n  color: #1f2937;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.vendor-cancel-button:hover {\n  background-color: #9ca3af;\n}\n\n/* Table */\n.vendor-table-container {\n  overflow-x: auto;\n}\n\n.vendor-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.vendor-table-header {\n  background-color: #f3f4f6;\n}\n\n.vendor-table-th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.vendor-table-row {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.vendor-table-row:hover {\n  background-color: #f9fafb;\n}\n\n.vendor-table-td {\n  padding: 12px;\n}\n\n.vendor-edit-button {\n  /* background-color: #eab308; */\n  color: rgb(0, 0, 0);\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: none;\n  font-size: 0.875rem;\n  cursor: pointer;\n  margin-right: 8px;\n  transition: background-color 0.2s;\n}\n\n.vendor-edit-button:hover {\n  /* background-color: #ca8a04; */\n}\n\n.vendor-delete-button {\n  /* background-color: #ef4444; */\n  color: rgb(0, 0, 0);\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: none;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.vendor-delete-button:hover {\n  /* background-color: #dc2626; */\n}\n\n.vendor-no-data {\n  text-align: center;\n  color: #6b7280;\n  padding: 16px;\n}\n\n/* Responsive Design */\n@media (min-width: 640px) {\n  .vendor-controls {\n    flex-direction: row;\n  }\n\n  .vendor-form-container {\n    max-width: 500px;\n  }\n}\n\n@media (max-width: 639px) {\n  .vendor-container {\n    padding: 12px;\n  }\n\n  .vendor-table-th,\n  .vendor-table-td {\n    padding: 8px;\n  }\n\n  .vendor-edit-button,\n  .vendor-delete-button {\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
